import { Controller } from "@hotwired/stimulus";

// Submits the wrapped form on change and stops click propagation so the
// surrounding row's link doesn't fire while the user uses the control.
export default class extends Controller {
  static targets = ["form"];

  submit() {
    this.formTarget.requestSubmit();
  }

  stop(event) {
    event.stopPropagation();
  }
}
